<div class="frame180-frame180" [ngClass]="{'cursor-pointer': isActive || isDone}" [routerLink]="isDone || isActive || wasAlreadyVisited? link : null">
  <div class="frame180-sidebaritem" [ngClass]="{'frame180-sidebaritem2': isActive, 'frame180-sidebaritem3': !isActive && !isDone && !wasAlreadyVisited}">
    <div [ngClass]="{'frame180-icon2': isActive || !isDone, 'icon': isDone}"></div>
    <span class="frame180-text"><span>{{i18nKey}}</span></span>
  </div>
</div>
